export default function PHP___tostring() {
  return (
    <div>
      <h1>PHP___tostring</h1>
    </div>
  );
}
